const cities = require('./cities.json');
const slugifyCity = (city) => city.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
  .toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');

const cityPages = Object.fromEntries(cities.map((city) => [
  `/marabout/${slugifyCity(city)}`,
  {
    kind: 'city', city,
    title: `Marabout à ${city} | Maître Diamma`,
    heading: `Marabout africain à ${city} — Maître Diamma`,
    description: `Maître Diamma à ${city}, en Guadeloupe : retour affectif, voyance et protection spirituelle. Contact par téléphone ou WhatsApp au +33 7 45 44 96 41.`,
    label: `Marabout à ${city}`,
  },
]));

const servicePages = {
  '/voyance-guadeloupe': {
    kind: 'service', serviceId: 7,
    title: 'Voyance en Guadeloupe | Maître Diamma',
    heading: 'Voyance et consultation de médium en Guadeloupe',
    description: 'Consultation de voyance avec Maître Diamma en Guadeloupe : vie amoureuse, professionnelle et familiale. Échangez par téléphone ou WhatsApp au +33 7 45 44 96 41.',
    label: 'Voyance en Guadeloupe',
  },
  '/desenvoutement-guadeloupe': {
    kind: 'service', serviceId: 6,
    title: 'Désenvoûtement en Guadeloupe | Maître Diamma',
    heading: 'Désenvoûtement et protection spirituelle en Guadeloupe',
    description: 'Désenvoûtement, purification et protection spirituelle en Guadeloupe avec Maître Diamma. Contact direct par téléphone ou WhatsApp au +33 7 45 44 96 41.',
    label: 'Désenvoûtement en Guadeloupe',
  },
};

const articlePages = {
  '/blog/desenvoutement-lamentin-guadeloupe': {
    kind: 'article', city: 'Lamentin', serviceId: 6,
    title: 'Désenvoûtement à Lamentin | Maître Diamma',
    heading: 'Désenvoûtement à Lamentin, en Guadeloupe',
    description: 'Retrouvez les prestations de désenvoûtement et de protection spirituelle de Maître Diamma à Lamentin, ainsi que ses coordonnées pour une consultation.',
    label: 'Désenvoûtement à Lamentin',
  },
};

module.exports = { restoredPages: { ...cityPages, ...servicePages, ...articlePages }, slugifyCity };